<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h1>ログイン</h1>
                <p class="text-muted">メールアドレスとパスワードを入力し「ログイン」してください</p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                  <input type="text" class="form-control" v-model="username" placeholder="メールアドレス" autofocus v-on:keyup.enter="signIn" />
                </b-input-group>
                <b-input-group class="mb-4">
                  <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                  <input type="password" class="form-control" v-model="password" placeholder="パスワード" v-on:keyup.enter="signIn" />
                </b-input-group>
                <b-row>
                  <b-col cols="6">
                    <b-button variant="primary" class="px-4" v-on:click="signIn" :disabled="!username || !password">ログイン</b-button>
                  </b-col>
                  <b-col cols="6" class="text-right">
                    <!-- <b-button variant="link" class="px-0" v-on:click="forgot">パスワード忘れ</b-button> -->
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { Auth, Logger, JS } from "aws-amplify";
import AmplifyStore from "../../AmplifyStore";
import AmplifyTheme from "../../AmplifyTheme";

const logger = new Logger("SignInComp");

export default {
  name: "SignIn",
  data() {
    return {
      username: "",
      password: "",

      user: null,
      confirmView: false,
      code: "",

      error: "",
      theme: AmplifyTheme
    };
  },
  methods: {
    signIn: function(event) {
      const that = this;
      Auth.signIn(this.username, this.password)
        .then(user => {
          logger.debug("sign in success", user);
          AmplifyStore.commit("setUser", user);
          return user;
        })
        .then(user => {
          that.user = user;
          if (user.challengeName === "SMS_MFA") {
            that.confirmView = true;
            return;
          }
          this.checkUser();
        })
        .catch(err => this.setError(err));
    },
    checkUser: function() {
      const user = this.user;
      if (!user) {
        return;
      }

      Auth.verifiedContact(user).then(data => {
        logger.debug("verify result", data);
        AmplifyStore.commit("setUserVerification", data);
        if (!JS.isEmpty(data.verified)) {
          this.$router.push("/");
        } else {
          this.$router.push("/auth/verifyContact");
        }
      });
    },
    confirm: function() {
      Auth.confirmSignIn(this.user, this.code)
        .then(() => {
          this.$router.push("/");
        })
        .catch(err => this.setError(err));
    },
    forgot: function() {
      this.$router.push("/auth/forgotPassword");
    },
    signUp: function() {
      this.$router.push("/auth/signUp");
    },
    setError: function(err) {
      this.error = err.message || err;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/amplify/components/auth/SignIn.vue